import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import teams_api from "../api/protected/teams";
import organisations_api from "../api/protected/organisations";
import OrganisationsTeamsGridContainer from "../containers/OrganisationsTeamsGridContainer";
import OrganisationForm from "../components/organisations/OrganisationForm";
import Slider from "../components/Slider";
import DeleteDialog from "../components/DeleteDialog";
import deleteIcon from "../assets/delete-icon.svg";
import back_arrow from "../assets/backarrow.svg";


const EditOrganisation = () => {
    const navigate = useNavigate()
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams()

    const [organisationId, setOrganisationId] = useState("")
    const [isDemo, setIsDemo] = useState(false)

    const [organisation, setOrganisation] = useState(null)
    const [organisationName, setOrganisationName] = useState("");
    const [organisationDescription, setOrganisationDescription] = useState("");
    const [organisationSector, setOrganisationSector] = useState(0)
    const [organisationLogo, setOrganisationLogo] = useState()
    const [editor, setEditor] = useState(false)

    const [teams, setTeams] = useState();

    const [newTeam, setNewTeam] = useState("")

    const [showDelete, setShowDelete] = useState();
    const buttons = [{"text":"Delete", "id": "1"}, {"text":"Cancel", "id": "2"}];

    const [showDeleteHover, setShowDeleteHover] = useState(false)
    const [showHidden, setShowHidden] = useState()

    useEffect(() => {
        if (!params.organisationId) return;
        if(searchParams.get('demo')) {
            setIsDemo(true);
        }
        setOrganisationId(params.organisationId)
    }, [params.organisationId]);

    useEffect(() => {
        if (!organisationId) return;
        getOrganisation()
        getTeams();
    }, [organisationId, isDemo]);

    const getOrganisation = () => {
        if (!organisationId) return;

        if(isDemo) {
            let response = organisations_api.getDemoOrganisation(organisationId);
            response.then(response => {
                if (response.data.demo_organisations.length === 0) BackToOrganisations()
                let data = response.data.demo_organisations[0];
                setOrganisation(data)
                setOrganisationLogo(data.logo)
                setOrganisationName(data.name)
                setOrganisationDescription(data.description)
                setOrganisationSector(data.sector);
                setEditor(false)
            })
        } else {
            let response = organisations_api.getOrganisation(organisationId);
            response.then(response => {
                if (response.data.organisations.length === 0) BackToOrganisations()
                let data = response.data.organisations[0];
                setOrganisation(data);
                setOrganisationLogo(data.logo)
                setOrganisationName(data.name);
                setOrganisationDescription(data.description);
                setShowHidden(data.hidden);
                setOrganisationSector(data.sector);
                setEditor(data.editor)
            })
        }


    }

    const deleteOrganisation = () => {
        if (!organisationId || organisation.demo) return;
        let response = organisations_api.deleteOrganisation(organisationId);
        response.then(() => {
            navigate("/organisations")
        })
    }

    const getTeams = () => {
        if (!organisationId) return;
        if(isDemo) {
            let response = teams_api.getDemoTeamsByOrganisationID(organisationId)
            response.then(response => {
                setTeams(response.data.teams)
            })
        } else {
            let response = teams_api.getTeamsByOrganisationID(organisationId);
            response.then(response => {
                setTeams(response.data.teams);
            })
        }
    }

    const formSubmit = (ev) => {
        if (!ev || !newTeam) return;
        navigate("/teams?name=" + newTeam + "&organisation=" + organisationId)
    }

    const handleTeamClick = (team) => {
        if(isDemo) {
            navigate(`/teams/${team.id}?demo=true`)
        } else {
            navigate(`/teams/${team.id}`)
        }
    }

    const BackToOrganisations = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate("/organisations")
        }
    }

    const updateToggleHidden = () => {
        setShowHidden(!showHidden);
    }

    const handleDeleteClick = () => {
        setShowDelete(!showDelete)
    }

    const handleDeleteResult = (result) => {
        if (result === "1") deleteOrganisation();
        setShowDelete(false)
    }

    const handleDeleteHoverOn = () => {
        setShowDeleteHover(true)
    }

    const handleDeleteHoverOut = () => {
        setShowDeleteHover(false)
    }

    useEffect(() => {
        const body = {"hidden": showHidden}
        let response = organisations_api.putOrganisationVisibility(organisationId, body);
        response.catch(err => {console.log(err)})
    }, [showHidden]);


    return (
        <div className="organisations-page-background-container">
            <div className="organisations-page-container">
                <div className="back-link link" onClick={() => BackToOrganisations()}>
                    <img className={"back-arrow-classname"} src={back_arrow} alt={"Back Arrow"}/>
                </div>
                {organisation && organisation ?
                    <>
                        <div className="organisations-page-header">
                            <div className="organisation-header-logo-container"
                                 style={{backgroundColor: organisation.colour ? `#${organisation.colour}` : '#0082CA'}}>
                                {organisation && organisation.logo ?
                                    <img src={organisation && organisation.logo} alt={organisation && organisation.name + " Logo"}
                                         className="organisation-card-logo"/>
                                    : null}
                            </div>
                            <div className="organisations-page-title">{organisationName ? organisationName : "Edit Organisation"}</div>
                            <div className="col">
                                <div className="header-icon-container">
                                    {editor ?
                                        <div className="header-slider-container">
                                            <Slider update={updateToggleHidden.bind(this)} state={showHidden} type="Organisation"/>
                                            <div className="header-hide-text">Hide</div>
                                        </div> : null
                                    }
                                    <div className="header-delete-container" onMouseOver={handleDeleteHoverOn}
                                         onClick={handleDeleteClick} onMouseLeave={handleDeleteHoverOut}>
                                        <img className="header-delete-icon link" src={deleteIcon} alt="Delete Organisation"/>
                                        {showDeleteHover ?
                                            <div className="delete-tooltip-container">
                                                <div className="delete-tooltip-text">
                                                    Delete Organisation
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <OrganisationForm buttonText={"Update"} organisationName={organisationName && organisationName}
                                     organisationDescription={organisationDescription && organisationDescription}
                                     organisationLogo={organisationLogo && organisationLogo}
                                     organisationSector={organisationSector && organisationSector} organisationID={organisation && organisation.id}
                                     updateData={getOrganisation.bind(this)} editor={editor}
                                     organisationDemo={organisation && organisation.demo}
                        />
                        <div className="organisation-form-container">
                            <div className="organisation-form-title">Teams</div>
                            <OrganisationsTeamsGridContainer teams={teams} handleClick={handleTeamClick}/>
                            {editor ?
                                <div className="organisation-add-team-container">
                                    <div className="field-input">
                                        <div className="label">Team Name</div>
                                        <div className="field-input-entry">
                                            <input className="organisation-name-input" name="organisation.name" type="text"
                                                   value={newTeam} required
                                                   onChange={ev => setNewTeam(ev.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="field-input left-spacer">
                                        <button className="update-organisation-button team-member link" name="method"
                                                type="submit" value="team_name" disabled={!newTeam} onClick={formSubmit}>
                                            Save & Continue
                                        </button>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    </> : null
                }
                {showDelete ?
                    <DeleteDialog title={"Delete Organisation"} type={"Organisation"} name={organisationName && organisationName}
                                  description={organisationDescription && organisationDescription} buttons={buttons}
                                  result={handleDeleteResult.bind(this)}/>
                    : null
                }
            </div>
        </div>
    )
}

export default EditOrganisation